import { MenuItem } from '@mui/material'
import { Select } from '@mui/material'
import React from 'react'
import { InvoicePaymentType } from '../../services/api/sharedTypes/Invoice'

interface InvoicePaymentTypeSelectProps {
    value: InvoicePaymentType
    onChange: (value: InvoicePaymentType) => void
}

const InvoicePaymentTypeSelect: React.FC<InvoicePaymentTypeSelectProps> = ({ value, onChange }: InvoicePaymentTypeSelectProps) => {
    return (
        <Select
            value={value}
            onChange={(e) => onChange(e.target.value as InvoicePaymentType)}
            fullWidth
            style={{ maxHeight: 36 }}
            size='small'
        >
            <MenuItem value={InvoicePaymentType.NotSet}>Neurčeno</MenuItem>
            <MenuItem value={InvoicePaymentType.Cash}>Hotově</MenuItem>
            <MenuItem value={InvoicePaymentType.WireTransfer}>Převodem</MenuItem>
        </Select>
    )
}

export default InvoicePaymentTypeSelect